import { TranslationKeys } from '~frontend-common/i18n/english/disclaimer.i18n';

const keys: TranslationKeys = {
  disclaimer: {
    titles: {
      home: 'Mon domicile:',
      car: 'Ma voiture:',
      policyholder: {
        title: 'Moi ou <0>un membre de mon ménage:</0>',
        toolTip:
          'Vous devez obtenir le consentement des membres de votre ménage avant de répondre aux affirmations ci-dessous.',
      },
    },
    statements: {
      car: {
        carHasOutstandingLoss: {
          description: 'A des sinistres en suspens, une réclamation en cours ou des dommages non réparés.',
        },
        carryDangerousMaterial: {
          description: 'Est utilisée pour transporter des <0>matières dangereuses</0>.',
          tooltip: 'Tels que des explosifs ou des matières radioactives',
        },
        isRebuilt: {
          description: 'Est modifiée, reconstruite ou utilisée à des fins de compétition, d’exhibition ou de courses.',
        },
        isRegisteredOutsideOfBoundaries: {
          description:
            'Est immatriculée hors de ma province de résidence, ou est garée loin de mon adresse personnelle.',
        },
        isUsedForBusiness: {
          // FIXME: This is a test running to check if the amount of users select isUsedBusiness reduces
          // description: 'Est utilisée à des <0>fins professionnelles</0>.',
          // tooltip: 'Conduire pour des applications comme Uber ou Turo est un usage professionnel.',
          description: 'Est utilisée à des fins professionnelles (ex. Uber ou Turo).',
        },
      },
      home: {
        exceedsNumberOfResidents: {
          description: {
            condo: {
              on: 'A 2 colocataires ou plus ne faisant pas partie de ma famille qui habitent avec moi dans mon unité.',
              qc: 'A 3 colocataires ou plus ne faisant pas partie de ma famille qui habitent avec moi dans mon unité.',
            },
            homeowner: {
              on: 'A 2 colocataires ou plus ne faisant pas partie de ma famille qui habitent avec moi dans ma maison.',
              qc: 'A 3 colocataires ou plus ne faisant pas partie de ma famille qui habitent avec moi dans ma maison.',
            },
            tenant: {
              on: 'A 3 colocataires ou plus ne faisant pas partie de ma famille qui habitent avec moi dans mon unité.',
              qc: 'A 3 colocataires ou plus ne faisant pas partie de ma famille qui habitent avec moi dans mon unité.',
            },
          },
        },
        homeHasOutstandingLoss: {
          description:
            'Est en construction, des <0>rénovations majeures</0> sont en cours, a des sinistres en suspens, a une réclamation en attente ou a des dommages non réparés.',
          tooltip:
            'Remplacement de tuyauterie ou la rénovation de la cuisine sont considérés comme des rénovations majeures.',
        },
        isCondoCorpUnderInsured: {
          description:
            "Fait partie d'un Syndicat de Copropriété qui n'est pas assuré ou est seulement partiellement assuré.",
        },
        isMobileHome: { description: 'Est une maison mobile.' },
        isSecondaryResidence: {
          description: {
            condo: "Est une résidence secondaire, n'est pas occupée par le propriétaire ou sera vacante.",
            homeowner: "Est une résidence secondaire, n'est pas occupée par le propriétaire ou sera vacante.",
            tenant: 'Est une résidence secondaire ou sera vacante.',
          },
        },
        isUsedForCommercialActivity: {
          description: 'Est utilisée pour une <0>activité commerciale</0>.',
          tooltip:
            "Les entreprises à domicile ou la location d'espace comme Swimply sont considérées comme une activité commerciale.",
        },
        isUsedForRental: {
          description: 'Est utilisée pour de la <0>location court-terme</0> ou la sous-location.',
          tooltip:
            'La location de séjour via des applications comme Airbnb ou la location de chambre est considérée comme une location de courte durée.',
        },
      },
      policyholder: {
        hasMedicalConditions: { description: 'A un permis de conduire indiquant des restrictions médicales affectant la conduite.' },
        hasSuspendedLicence: {
          description: 'A eu le permis de conduire suspendu ou révoqué dans les 5 dernières années.',
        },
        haveBeenBankrupt: {
          description: "Avoir déjà fait faillite. Une faillite libérée depuis 3 ans ou plus n'est pas considérée.",
        },
        haveBeenRefused: {
          description:
            "S'est vu refuser une police d’assurance ou vu sa police d'assurance annulée. Un refus de renouvellement est considéré comme une annulation.",
        },
        haveCriminalRecord: {
          description: 'A un casier judiciaire ou une poursuite judiciaire en cours contre vous.',
        },
        haveExoticAnimal: {
          description:
            "Possède un chien d'une race qui pourrait être considérée comme <0>dangereuse</0> ou un animal exotique, un animal de selle, un animal de ferme ou un reptile.",
          tooltip: 'Pitbull, doberman, rottweiler, etc. sont considérés comme des races dangereuses.',
        },
      },
    },
  },
};

export default keys;
